import React, { useEffect, useState } from 'react';
import { Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { listBlogs, deleteBlog } from './Blog.service';
import { Link, useNavigate } from 'react-router-dom';
import { useCountryParam, buildUrlWithCountry } from '../../common/util/useCountryParam';

const BlogTable: React.FC = () => {
  const [blogs, setBlogs] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();
  const country = useCountryParam();

  const fetch = async () => {
    setLoading(true);
    try {
      const params = query ? `?search=${encodeURIComponent(query)}` : '';
      const res: any = await listBlogs(params);
      setBlogs(res || []);
    } catch (err) {
      console.error(err);
      setBlogs([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm('Delete this blog?')) return;
    try {
      await deleteBlog(id);
      fetch();
    } catch (err) {
      console.error(err);
      alert('Delete failed');
    }
  };

  const openCreate = () => navigate(buildUrlWithCountry('/addBlog', country));
  const openEdit = (b: any) => navigate(buildUrlWithCountry(`/editBlog/${b._id || b.id}`, country));

  return (
    <Box sx={{ paddingY: 6, width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
        <h2>Blogs List</h2>

        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <TextField placeholder="Search title/excerpt/content" value={query} onChange={(e) => setQuery(e.target.value)} size="small" />
          <Button variant="contained" sx={{
            backgroundColor: "#10374A",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#08293D" },
            height: '40px'
          }}   onClick={() => fetch()}>Search</Button>
          <Button variant="contained" color="primary" size='small' sx={{
            backgroundColor: "#10374A",
            color: "#FFFFFF",
            "&:hover": { backgroundColor: "#08293D" },
            height: '40px'
          }} startIcon={<AddIcon />} onClick={openCreate}>Add Blog</Button>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Title</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Featured</TableCell>
              <TableCell>Views</TableCell>
              <TableCell>Published</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {blogs.map((b) => (
              <TableRow key={b._id || b.id}>
                <TableCell>{b.title}</TableCell>
                <TableCell>{b.category}</TableCell>
                <TableCell>{b.featured ? 'Yes' : 'No'}</TableCell>
                <TableCell>{b.views ?? 0}</TableCell>
                <TableCell>{b.publishedAt ? new Date(b.publishedAt).toLocaleDateString() : ''}</TableCell>
                <TableCell>
                  <Tooltip title="Edit"><IconButton size="small" component={Link} to={`/editBlog/${b._id || b.id}`}><EditIcon fontSize="small"/></IconButton></Tooltip>
                  <Tooltip title="Delete"><IconButton size="small" onClick={() => handleDelete(b._id || b.id)}><DeleteIcon fontSize="small"/></IconButton></Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BlogTable;
